import axiosInstance from "../../../configurations/Axios";
import {API_ENDPOINTS} from "../../../constant/APIEndPoints";



export const submitTnCRequest = async (tnCRequestModel) => {
    try {
        const apiResponse = await axiosInstance.post(API_ENDPOINTS.ACCEPT_TNC, tnCRequestModel);
        return apiResponse.data;
    } catch (error) {
        console.log(error);
        throw new Error(error);
    }
}